/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ChalkboardSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M240,192h-8V56a16.01833,16.01833,0,0,0-16-16H40A16.01833,16.01833,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-40,0H128V176a7.99993,7.99993,0,0,1,8-8h56a7.99993,7.99993,0,0,1,8,8Z" />
    </Svg>
  );
}

export default ChalkboardSimple;
